<div class="flex-column align-center-center flex">
    <ng-lottie [options]="options" (animationCreated)="animationCreated($event)" [ngStyle]="{'width.px': width()}"></ng-lottie>
    <span>{{msgError()}}</span>
</div>
